var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseActionMenu',{attrs:{"actions":_vm.getUnassignedUserStoryActions(),"always-visible":""}})}
var staticRenderFns = []

export { render, staticRenderFns }